import rest from "@/rest-client";
import createCrudVuexModule from "@/store/crud";

export const processCategory = createCrudVuexModule({
  namespaced: true,
  path: "/library/process-category",
  moduleName: `process-category`,
});
export const process = createCrudVuexModule({
  namespaced: true,
  path: "/library/process",
  moduleName: `process`,

  state: {
    recommendations: undefined,
  },
  getters: {
    recommendations(state) {
      return state.recommendations;
    },
  },
  mutations: {
    recommendations(state, value) {
      state.recommendations = value;
    },
  },
  actions: {
    async paginateRecommendation({ commit }, { pagination, level, id }, clearStateBeforeRest = false) {
      commit("isLoading", true);
      try {
        if (clearStateBeforeRest) {
          commit("recommendations", undefined);
        }
        const response = await rest.post(`/recommendation/paginate/${level}/${id}`, { pagination });
        commit("recommendations", response.data);
        return response;
      } finally {
        commit("isLoading", false);
      }
    },
  },
});

export const workspaceProcessCategory = createCrudVuexModule({
  namespaced: true,
  path: "/workspace/library/process-category",
});

export const workspaceProcess = createCrudVuexModule({
  namespaced: true,
  path: "/workspace/library/process",
});

export const managementProcessCategory = createCrudVuexModule({
  namespaced: true,
  path: "/management/library/process-category",
});

export const managementProcess = createCrudVuexModule({
  namespaced: true,
  path: "/management/library/process",
});
